import { ToggleTip } from '@betterment/samba-react';

export const TaxLossHarvestingToggletip = ({ isEnabled }: { isEnabled: boolean }) => {
  const enabledModifier = isEnabled ? '' : 'can ';
  const tooltipText = `We ${enabledModifier}actively monitor eligible accounts for opportunities to sell holdings at a loss to help reduce your taxes.`;

  return (
    <ToggleTip>
      <ToggleTip.Trigger label="Tax Loss Harvesting Information" css={{ ml: 'space.50' }} />
      <ToggleTip.Content align="start" side="left" css={{ maxWidth: '300px', width: 'max-content' }}>
        {tooltipText}
      </ToggleTip.Content>
    </ToggleTip>
  );
};
